export const styles = {
  documentSelector: {
    marginBottom: '1rem',
  },
  flexContainer: {
    display: 'flex',
  },
}
